<ng-container *ngIf="service == 'accounts'">
    <app-accounts-form></app-accounts-form>
</ng-container>